var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.footerClass],style:(['font-size: 0.875rem', _vm.footerStyle])},[_vm._v(" "+_vm._s(_vm.footerValue)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }